module.exports = __webpack_public_path__ + "img/el_alquimista-isotipo_blanco.979c22fc.svg";